import React, { useState } from "react";
import { ISelectOption } from "../forms/util";
import { TakeFivePage } from "./TakeFivePage";
import { takeFiveOverview } from "./TakeFivePageSelector";
import { TakeFiveCardList } from "./TakeFiveCardList";
import { TakeFiveView } from "./TakeFiveView";
import './TakeFive.css'

interface TakeFiveSectionProps {
    page: ISelectOption,
    pageView: TakeFiveView
}

export const TakeFiveSection = (props: TakeFiveSectionProps) => { // based on FatigueAssessmentDashboard
    const [selectedPage] = useState(props.page ?? takeFiveOverview);
    const [pageView] = useState(props.pageView ?? TakeFiveView.Overview);

    const getPageTitle = () => {
        var title = selectedPage.label;
        return title;
    }

    const pageTitle = getPageTitle();

    return (
        <TakeFivePage key={selectedPage.value} selectedPage={selectedPage}>
            <div className="tf-list-container">
                <TakeFiveCardList
                    view={[pageView]}
                    title={pageTitle}
                />
            </div>
        </TakeFivePage>
    );
};